import React, { FC } from 'react'
import { cn } from '../../../shared/utils'
import styles from '../Story.module.scss'
import { useStoryContext } from '../StoryContext'
import { Badge } from '@wmgtech/legato'

type TStoryTagsProps = {}

export const StoryTags: FC<TStoryTagsProps> = (props) => {
  const story = useStoryContext()
  return (
    <div className={cn(styles.tags)}>
      {story.tags?.map((tag) => (
        <Badge
          key={tag.id}
          className={styles.tag}
          containerStyle="outline"
          colorType="dark"
          text={tag.label}
          size="xs"
        />
      ))}
    </div>
  )
}
